import {IntegrationService} from "../api";
import Alpine from "alpinejs";

export const getOrderTotal = async () => {
	try {
		const response = await IntegrationService.getOrderTotal();
		if (response.response.status === 200) {
			if (response.data) {
				Alpine.store("orderTotal", response.data);
			}
		}
	} catch (error) {
		console.error("Error fetching order total:", error);
	}
};
